module.exports = __webpack_public_path__ + "static/media/doubleShieldPykes.c94813f5.jpg";